// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/util/tendermint_proxy/v1/tendermint_proxy.proto (package penumbra.util.tendermint_proxy.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { DefaultNodeInfo } from "../../../../tendermint/p2p/types_pb.js";
import { Validator } from "../../../../tendermint/types/validator_pb.js";
import { ProofOps } from "../../../../tendermint/crypto/proof_pb.js";
import { BlockID } from "../../../../tendermint/types/types_pb.js";
import { Block } from "../../../../tendermint/types/block_pb.js";
/**
 * GetTxRequest is the request type for the GetTx RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetTxRequest
 */
export class GetTxRequest extends Message {
    /**
     * Hash of transaction to retrieve
     *
     * @generated from field: bytes hash = 1;
     */
    hash = new Uint8Array(0);
    /**
     * Include proofs of the transaction's inclusion in the block
     *
     * @generated from field: bool prove = 2;
     */
    prove = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetTxRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "prove", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetTxRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTxRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTxRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTxRequest, a, b);
    }
}
/**
 * GetTxResponse is the response type for the GetTx RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetTxResponse
 */
export class GetTxResponse extends Message {
    /**
     * Hash of transaction
     *
     * @generated from field: bytes hash = 1;
     */
    hash = new Uint8Array(0);
    /**
     * @generated from field: uint64 height = 2;
     */
    height = protoInt64.zero;
    /**
     * @generated from field: uint64 index = 3;
     */
    index = protoInt64.zero;
    /**
     * @generated from field: penumbra.util.tendermint_proxy.v1.TxResult tx_result = 4;
     */
    txResult;
    /**
     * @generated from field: bytes tx = 5;
     */
    tx = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetTxResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "tx_result", kind: "message", T: TxResult },
        { no: 5, name: "tx", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetTxResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTxResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTxResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTxResponse, a, b);
    }
}
/**
 * @generated from message penumbra.util.tendermint_proxy.v1.TxResult
 */
export class TxResult extends Message {
    /**
     * @generated from field: string log = 1;
     */
    log = "";
    /**
     * @generated from field: uint64 gas_wanted = 2;
     */
    gasWanted = protoInt64.zero;
    /**
     * @generated from field: uint64 gas_used = 3;
     */
    gasUsed = protoInt64.zero;
    /**
     * @generated from field: repeated penumbra.util.tendermint_proxy.v1.Tag tags = 4;
     */
    tags = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.TxResult";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "gas_wanted", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "gas_used", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "tags", kind: "message", T: Tag, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new TxResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TxResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TxResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TxResult, a, b);
    }
}
/**
 * @generated from message penumbra.util.tendermint_proxy.v1.Tag
 */
export class Tag extends Message {
    /**
     * @generated from field: bytes key = 1;
     */
    key = new Uint8Array(0);
    /**
     * @generated from field: bytes value = 2;
     */
    value = new Uint8Array(0);
    /**
     * @generated from field: bool index = 3;
     */
    index = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.Tag";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "index", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new Tag().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Tag().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Tag().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Tag, a, b);
    }
}
/**
 * BroadcastTxAsyncRequest is the request type for the BroadcastTxAsync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncRequest
 */
export class BroadcastTxAsyncRequest extends Message {
    /**
     * @generated from field: bytes params = 1;
     */
    params = new Uint8Array(0);
    /**
     * @generated from field: uint64 req_id = 2;
     */
    reqId = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "params", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "req_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTxAsyncRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTxAsyncRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTxAsyncRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTxAsyncRequest, a, b);
    }
}
/**
 * BroadcastTxAsyncResponse is the response type for the BroadcastTxAsync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncResponse
 */
export class BroadcastTxAsyncResponse extends Message {
    /**
     * @generated from field: uint64 code = 1;
     */
    code = protoInt64.zero;
    /**
     * @generated from field: bytes data = 2;
     */
    data = new Uint8Array(0);
    /**
     * @generated from field: string log = 3;
     */
    log = "";
    /**
     * @generated from field: bytes hash = 4;
     */
    hash = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTxAsyncResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTxAsyncResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTxAsyncResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTxAsyncResponse, a, b);
    }
}
/**
 * BroadcastTxSyncRequest is the request type for the BroadcastTxSync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxSyncRequest
 */
export class BroadcastTxSyncRequest extends Message {
    /**
     * @generated from field: bytes params = 1;
     */
    params = new Uint8Array(0);
    /**
     * @generated from field: uint64 req_id = 2;
     */
    reqId = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.BroadcastTxSyncRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "params", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "req_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTxSyncRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTxSyncRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTxSyncRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTxSyncRequest, a, b);
    }
}
/**
 * BroadcastTxSyncResponse is the response type for the BroadcastTxSync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxSyncResponse
 */
export class BroadcastTxSyncResponse extends Message {
    /**
     * @generated from field: uint64 code = 1;
     */
    code = protoInt64.zero;
    /**
     * @generated from field: bytes data = 2;
     */
    data = new Uint8Array(0);
    /**
     * @generated from field: string log = 3;
     */
    log = "";
    /**
     * @generated from field: bytes hash = 4;
     */
    hash = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.BroadcastTxSyncResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTxSyncResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTxSyncResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTxSyncResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTxSyncResponse, a, b);
    }
}
/**
 * GetStatusRequest is the request type for the Query/GetStatus RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetStatusRequest
 */
export class GetStatusRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetStatusRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetStatusRequest, a, b);
    }
}
/**
 * GetStatusResponse is the response type for the Query/GetStatus RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetStatusResponse
 */
export class GetStatusResponse extends Message {
    /**
     * @generated from field: tendermint.p2p.DefaultNodeInfo node_info = 1;
     */
    nodeInfo;
    /**
     * @generated from field: penumbra.util.tendermint_proxy.v1.SyncInfo sync_info = 2;
     */
    syncInfo;
    /**
     * @generated from field: tendermint.types.Validator validator_info = 3;
     */
    validatorInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetStatusResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "node_info", kind: "message", T: DefaultNodeInfo },
        { no: 2, name: "sync_info", kind: "message", T: SyncInfo },
        { no: 3, name: "validator_info", kind: "message", T: Validator },
    ]);
    static fromBinary(bytes, options) {
        return new GetStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetStatusResponse, a, b);
    }
}
/**
 * @generated from message penumbra.util.tendermint_proxy.v1.SyncInfo
 */
export class SyncInfo extends Message {
    /**
     * @generated from field: bytes latest_block_hash = 1;
     */
    latestBlockHash = new Uint8Array(0);
    /**
     * @generated from field: bytes latest_app_hash = 2;
     */
    latestAppHash = new Uint8Array(0);
    /**
     * @generated from field: uint64 latest_block_height = 3;
     */
    latestBlockHeight = protoInt64.zero;
    /**
     * @generated from field: google.protobuf.Timestamp latest_block_time = 4;
     */
    latestBlockTime;
    /**
     * These are implemented in tendermint, but not
     * in tendermint-rpc.
     * bytes earliest_block_hash = 5;
     * bytes earliest_app_hash = 6;
     * uint64 earliest_block_height = 7;
     * google.protobuf.Timestamp earliest_block_time = 8;
     *
     * @generated from field: bool catching_up = 9;
     */
    catchingUp = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.SyncInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "latest_block_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "latest_app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "latest_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "latest_block_time", kind: "message", T: Timestamp },
        { no: 9, name: "catching_up", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new SyncInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncInfo, a, b);
    }
}
/**
 * ABCIQueryRequest defines the request structure for the ABCIQuery gRPC query.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.ABCIQueryRequest
 */
export class ABCIQueryRequest extends Message {
    /**
     * @generated from field: bytes data = 1;
     */
    data = new Uint8Array(0);
    /**
     * @generated from field: string path = 2;
     */
    path = "";
    /**
     * @generated from field: int64 height = 3;
     */
    height = protoInt64.zero;
    /**
     * @generated from field: bool prove = 4;
     */
    prove = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.ABCIQueryRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "prove", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new ABCIQueryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ABCIQueryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ABCIQueryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ABCIQueryRequest, a, b);
    }
}
/**
 * ABCIQueryResponse defines the response structure for the ABCIQuery gRPC query.
 *
 * Note: This type is a duplicate of the ResponseQuery proto type defined in
 * Tendermint.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.ABCIQueryResponse
 */
export class ABCIQueryResponse extends Message {
    /**
     * @generated from field: uint32 code = 1;
     */
    code = 0;
    /**
     * nondeterministic
     *
     * @generated from field: string log = 3;
     */
    log = "";
    /**
     * nondeterministic
     *
     * @generated from field: string info = 4;
     */
    info = "";
    /**
     * @generated from field: int64 index = 5;
     */
    index = protoInt64.zero;
    /**
     * @generated from field: bytes key = 6;
     */
    key = new Uint8Array(0);
    /**
     * @generated from field: bytes value = 7;
     */
    value = new Uint8Array(0);
    /**
     * @generated from field: tendermint.crypto.ProofOps proof_ops = 8;
     */
    proofOps;
    /**
     * @generated from field: int64 height = 9;
     */
    height = protoInt64.zero;
    /**
     * @generated from field: string codespace = 10;
     */
    codespace = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.ABCIQueryResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "index", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 7, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 8, name: "proof_ops", kind: "message", T: ProofOps },
        { no: 9, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 10, name: "codespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ABCIQueryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ABCIQueryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ABCIQueryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ABCIQueryResponse, a, b);
    }
}
/**
 * GetBlockByHeightRequest is the request type for the Query/GetBlockByHeight RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetBlockByHeightRequest
 */
export class GetBlockByHeightRequest extends Message {
    /**
     * @generated from field: int64 height = 1;
     */
    height = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetBlockByHeightRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetBlockByHeightRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlockByHeightRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlockByHeightRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlockByHeightRequest, a, b);
    }
}
/**
 * GetBlockByHeightResponse is the response type for the Query/GetBlockByHeight RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetBlockByHeightResponse
 */
export class GetBlockByHeightResponse extends Message {
    /**
     * @generated from field: tendermint.types.BlockID block_id = 1;
     */
    blockId;
    /**
     * @generated from field: tendermint.types.Block block = 2;
     */
    block;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.util.tendermint_proxy.v1.GetBlockByHeightResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "block_id", kind: "message", T: BlockID },
        { no: 2, name: "block", kind: "message", T: Block },
    ]);
    static fromBinary(bytes, options) {
        return new GetBlockByHeightResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlockByHeightResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlockByHeightResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlockByHeightResponse, a, b);
    }
}
